import { render, staticRenderFns } from "./ResultQuizModal.vue?vue&type=template&id=6a471c7b&"
import script from "./ResultQuizModal.vue?vue&type=script&lang=js&"
export * from "./ResultQuizModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports